export default __webpack_public_path__ + "static/media/tool-no-data.fa1f90ee.png";